import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// Login Redux States
import { CHECK_LOGIN, LOGOUT_USER, REQUEST_OTP_USER, RESET_PASSWORD, SWITCH_USER, VERIFY_ADMIN } from './actionTypes';
import { apiError, loginUserSuccessful, logoutUserSuccess, requestOtpUserFail, requestOtpUserSuccess, resetPasswordUserFail, resetPasswordUserSuccess, switchUserFail, switchUserSuccess, verify_adminFail, verify_adminSuccess } from './actions';
import { push } from 'connected-react-router'; // Import the push function from connected-react-router

// AUTH related methods
import { loginApi, logoutApi, requestOTPApi, resetPasswordApi, switchUserApi, verifyAdminApi } from './api';
import Helpers from '../../../helpers/helpers';

//If user is login then dispatch redux action's are directly from here.

function* loginUser({ payload: { user, history, rememberMe } }) {
    try {
        const response = yield call(loginApi, user)
        // localStorage.setItem("authUser", JSON.stringify(response.data.profile));
        if (rememberMe) {
            localStorage.setItem("token", JSON.stringify(response.data.token));
        } else {
            sessionStorage.setItem("token", JSON.stringify(response.data.token));
            localStorage.setItem("token", JSON.stringify(response.data.token));
            setTimeout(()=>{
                localStorage.removeItem("token")
            }, 30000000)
        }
        yield put(loginUserSuccessful(response));

        history('/dashboard');
    } catch (error) {
        yield put(apiError(error));
    }
}

function* logoutUser() {
    try {

        const response = yield call(logoutApi);
        yield put(logoutUserSuccess(response));
        localStorage.removeItem('token');
        sessionStorage.removeItem('token')
        Helpers.routeToLogin();
        // history('/login');
    } catch (error) {
        yield put(apiError(error));
        Helpers.routeToLogin();
    }
}

function* verifyAdmin({ payload: { history } }) {
    console.log("heylja")
    try {
        const response = yield call(verifyAdminApi);
        console.log("response", response)
        if (response.code === "success") {
            yield put(verify_adminSuccess(response));
        } else {
            yield put(verify_adminFail(response));
            localStorage.removeItem('token');
            // yield put(push('/login'));
            return false
        }
    } catch (error) {
        console.log("error?", error)
        yield put(apiError(error));
    }
}

function* requestOTP({ payload }) {
    try {
        const response = yield call(requestOTPApi, payload);
        if (response.code === "success") {
            yield put(requestOtpUserSuccess(response));
        } else {
            yield put(requestOtpUserFail(response));
            return false
        }
    } catch (error) {
        yield put(apiError(error));
    }
}

function* resetPassword({ payload }) {
    try {
        const response = yield call(resetPasswordApi, payload);
        if (response.code === "success") {
            yield put(resetPasswordUserSuccess(response));
        } else {
            yield put(resetPasswordUserFail(response));
            return false
        }
    } catch (error) {
        yield put(apiError(error));
    }
}

function* switchUser({ payload }) {
    try {
        const response = yield call(switchUserApi, payload);
        if (response.code === "success") {
            yield put(switchUserSuccess(response));
        } else {
            yield put(switchUserFail(response));
            return false
        }
    } catch (error) {
        yield put(apiError(error));
    }
}

export function* watchUserLogin() {
    yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser);
}

function* loginSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout),
    ]);
    yield takeEvery(VERIFY_ADMIN, verifyAdmin)
    yield takeEvery(REQUEST_OTP_USER, requestOTP)
    yield takeEvery(SWITCH_USER, switchUser)
    yield takeEvery(RESET_PASSWORD, resetPassword)

}

export default loginSaga;